module.exports = __webpack_public_path__ + "img/statistics-icon01.c66b487c.png";